var styles = {"box":"Text_box_zzn47_1","title":"Text_title_zzn47_6","subtitle":"Text_subtitle_zzn47_16"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
